import { ContactModel } from '@akin-home/contacts';
import { useUpdateUserQuick } from '@akin-home/users/react';
import { useCallback } from 'react';
import { sendBackgroundMessage } from '../../chat/functions';
import { intent_labels } from '../../chat/intent_labels';
import { getCurrentUser } from '../../users/functions';
import { toggleInList } from '../../utils/arrays';

export const useSetContactFavourite = () => {
  const update_user = useUpdateUserQuick();

  return useCallback(
    (contact: ContactModel) => {
      const user = getCurrentUser();

      if (!user) return;

      const favouriteContacts = toggleInList(
        user.favouriteContacts || [],
        contact.id
      );

      update_user.mutate({
        input: {
          id: user.id,
          favouriteContacts,
        },
      });

      sendBackgroundMessage(intent_labels.favourite_contact, {
        context: {
          contact: {
            id: contact.id,
            name: contact.name,
            phone_number: contact.phoneNumbers[0]?.number,
            is_favourite: favouriteContacts.includes(contact.id),
          },
        },
      });
    },
    [update_user]
  );
};
